import { twMerge } from 'tailwind-merge';

interface Props {
    title: string;
    className?: string;
}

const SectionTitle = ({ title, className }: Props) => (
    <h3
        className={twMerge(
            'text-xs leading-6 font-bold antialiased',
            className,
        )}
    >
        {title}
    </h3>
);

export default SectionTitle;
